import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'
import { Box } from '@chakra-ui/react'

interface CustomIconProps extends IconProps {
  variant?: string
}

const EyeOutline = createIcon({
  displayName: 'EyeOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M14.122 9.88c1.171 1.171 1.171 3.072 0 4.245 -1.171 1.171-3.072 1.171-4.245 0 -1.171-1.171-1.171-3.072 0-4.245 1.173-1.173 3.073-1.173 4.245 1.77636e-15"></path>
        <path d="M3 12c0-.659.152-1.311.446-1.912v0c1.515-3.097 4.863-5.088 8.554-5.088 3.691 0 7.039 1.991 8.554 5.088v0c.294.601.446 1.253.446 1.912 0 .659-.152 1.311-.446 1.912v0c-1.515 3.097-4.863 5.088-8.554 5.088 -3.691 0-7.039-1.991-8.554-5.088v0c-.294-.601-.446-1.253-.446-1.912Z"></path>
      </g>
      <path fill="none" d="M0 0h24v24h-24v-24Z"></path>
    </>
  ),
})

const EyeTwoTone = createIcon({
  displayName: 'EyeTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="path" fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.1931 5.58187c2.33182 2.33182 2.33182 6.11245 0 8.44427 -2.33182 2.33182-6.11245 2.33182-8.44427 0 -2.33182-2.33182-2.33182-6.11245-1.77636e-15-8.44427 2.33182-2.33182 6.11245-2.33182 8.44427-1.77636e-15"
        ></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M14.15 14.06l5.85 5.93"></path>
      </Box>
    </>
  ),
})

const Eye: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={EyeTwoTone} {...props} />

  return <CustomIcon as={EyeOutline} {...props} />
}

export default memo(Eye)
